"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loyaltyTokenSelector = exports.currentAccountloyaltyTokenSelector = void 0;
var _reselect = require("reselect");
var _numberFormatter = require("../../helpers/numberFormatter");
var _positionSelectors = require("./positionSelectors");
var loyaltyTokenSelector = exports.loyaltyTokenSelector = (0, _reselect.createSelector)([function (state) {
  return state.loyaltyFee.loyaltyFees;
}, _positionSelectors.positionSelector], function (loyaltyFees, positions) {
  var loyaltyOMSProducts = [];
  var loyaltyOMSEnabled = true;
  positions = Object.keys(positions).map(function (p) {
    return positions[p];
  });
  loyaltyFees.forEach(function (token) {
    if (token.IsEnabled) {
      var product = positions.find(function (x) {
        return x.ProductId === token.LoyaltyProductId;
      });
      if (product) {
        var discount = token.LoyaltyDiscount * 100;
        var decimals = Math.floor(discount) !== discount ? discount.toString().split('.')[1].length || 0 : 0;
        product.LoyaltyDiscount = (0, _numberFormatter.formatNumberToLocale)(discount, decimals);
        loyaltyOMSProducts.push(product);
      }
    }
  });
  return {
    loyaltyOMSEnabled: loyaltyOMSEnabled,
    loyaltyOMSProducts: loyaltyOMSProducts
  };
});
var currentAccountloyaltyTokenSelector = exports.currentAccountloyaltyTokenSelector = (0, _reselect.createSelector)([function (state) {
  return state.user.accounts;
}, function (state) {
  return state.user.selectedAccountId;
}], function (accounts, selectedAccountId) {
  return accounts.find(function (account) {
    return selectedAccountId === account.AccountId;
  });
});